import { useI18n } from 'vue-i18n'
import { helpers, maxLength } from '@vuelidate/validators'
import { createEmailValidators, createRequiredValidator } from '@qicgroupdoha/qic-use'

const passportRegex = helpers.regex(/^(\d+|(?=.*\d)[A-Z0-9]+)$/)

export const useValidators = () => {
  const { t } = useI18n()
  const { withMessage } = helpers

  const required = createRequiredValidator(t('qic_error_empty_input'))
  const relationshipValidator = createRequiredValidator(t('qlm_select_relationship'))
  const nationalityValidator = createRequiredValidator(t('qlm_select_nationality'))
  const countryValidator = createRequiredValidator(t('qlm_select_country'))

  const emailValidator = createEmailValidators(
    t('qic_error_empty_input'),
    t('qic_error_invalid_input')
  )
  const passportValidator = {
    required,
    checkPassport: withMessage(t('qic_error_invalid_input'), passportRegex),
    maxLength: withMessage(t('qic_error_invalid_input'), maxLength(20)),
  }

  return {
    relationshipValidator,
    nationalityValidator,
    countryValidator,
    emailValidator,
    passportValidator,
    required,
    withMessage,
    createRequiredValidator,
  }
}
